"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetComponentsIdByTypeWithLink = exports.useGetComponentsIdByDepAndByType = exports.useGetComponentsByTypeAndId = exports.useGetComponentsByType = exports.useGetComponentsByDepAndByType = exports.useGetComponentByTypeAndId = exports.useGetComponentByDepByTypeAndById = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/selectors");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useGetComponentsByType = _ref => {
  let {
    type = ''
  } = _ref;
  return (0, _reactRedux.useSelector)((0, _selectors.selectActiveModelsByType)(type)) || {};
};
exports.useGetComponentsByType = useGetComponentsByType;
const useGetComponentByTypeAndId = _ref2 => {
  let {
    type = '',
    id = ''
  } = _ref2;
  return (0, _reactRedux.useSelector)((0, _selectors.selectActiveModelsByTypeAndById)({
    type,
    id
  }), (prev, next) => _paulCorePackage.functions.areEqual(prev, next)) || null;
};
exports.useGetComponentByTypeAndId = useGetComponentByTypeAndId;
const useGetComponentsByTypeAndId = _ref3 => {
  let {
    type = '',
    idList = []
  } = _ref3;
  const list = useGetComponentsByType({
    type
  }) || {};
  return idList.map(id => list[id]);
};
exports.useGetComponentsByTypeAndId = useGetComponentsByTypeAndId;
const useGetComponentsIdByTypeWithLink = _ref4 => {
  let {
    type = '',
    hasLinks = ''
  } = _ref4;
  return Object.values(useGetComponentsByType({
    type
  }) || {}).reduce((acc, c) => {
    var _c$hasLinks;
    return (_c$hasLinks = c[hasLinks]) !== null && _c$hasLinks !== void 0 && _c$hasLinks.length ? [...acc, c.id] : acc;
  }, []);
};
exports.useGetComponentsIdByTypeWithLink = useGetComponentsIdByTypeWithLink;
const useGetComponentsByDepAndByType = _ref5 => {
  let {
    type
  } = _ref5;
  return (0, _reactRedux.useSelector)((0, _selectors.selectStructureByDepAndByType)({
    type
  }), (prev, next) => _paulCorePackage.functions.areEqual(prev, next)) || {};
};
exports.useGetComponentsByDepAndByType = useGetComponentsByDepAndByType;
useGetComponentsByDepAndByType.propTypes = {
  type: _propTypes.default.oneOf([...Object.values(_constants.TypesByDep), ...Object.values(_constants.TypesConnect)])
};
const useGetComponentsIdByDepAndByType = _ref6 => {
  let {
    type = ''
  } = _ref6;
  return Object.keys(useGetComponentsByDepAndByType({
    type
  }));
};
exports.useGetComponentsIdByDepAndByType = useGetComponentsIdByDepAndByType;
const useGetComponentByDepByTypeAndById = _ref7 => {
  let {
    type = '',
    id = null
  } = _ref7;
  return (0, _reactRedux.useSelector)((0, _selectors.selectStructureByDepByTypeAndById)({
    type,
    id
  })) || null;
};
exports.useGetComponentByDepByTypeAndById = useGetComponentByDepByTypeAndById;